var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-page"},[(_vm.isLoading)?_c('div',{staticClass:"loading-spinner"}):_c('FullMonitorGrid',{attrs:{"cameras":_vm.cameras}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }